export const styles = {
  tableRow: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr 1fr',
    gap: '8px',
    borderBottom: '1px solid #F3F4F9',
    padding: '20px 18px 20px 28px',
  },

  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      cursor: 'pointer',
    },
  },

  tableRoleName: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '148%',
    color: '#8C8F9D',
  },
};
